import { useState } from 'react';

import FaveHeart from '@/components/app/contentPlayer/FaveHeart';
import { useMediaPlayerContext } from '@/components/app/contentPlayer/MediaPlayerProvider';
import ShareButton from '@/components/app/contentPlayer/ShareButton';
import ShareModal from '@/components/app/contentPlayer/ShareModal';

import { Wrapper } from './styles';
import { GuideActionsProps } from './types';

const GuideActions = ({ guide }: GuideActionsProps) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const { hideControls } = useMediaPlayerContext();

	return (
		<Wrapper>
			{!hideControls && <FaveHeart withBorder shouldShowText guideId={guide.id} guideTitle={guide.title} />}
			{!guide.capabilities?.non_shareable && (
				<ShareButton shouldShowText isShareModalVisible={setIsModalOpen} />
			)}
			<ShareModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
		</Wrapper>
	);
};

export default GuideActions;
